module.exports = __webpack_public_path__ + "img/09-avatar male.0312abd3.png";